import React from 'react';
import { Avatar } from '@material-ui/core';
import _get from 'lodash/get';
import styles from './styles';
import moment from 'moment';
import Tooltip from '@/components/Tooltip';

export default ({ DATA = {}, Open }) => {
  const cls = styles();

  function getTimeDisplay(dateStr) {
    const m = moment(dateStr);
    const diffHours = moment().diff(m, 'hours');

    if (diffHours < 24) {
      return m.fromNow();
    } else {
      return m.format('MM-DD-YYYY HH:mm');
    }
  }

  const handleSeen = (e) => {
    e.stopPropagation();
    e.preventDefault();
    console.log('handleSeen');
    Open(DATA, !DATA.seen, true);
  };

  return (
    <div
      className={DATA.seen ? cls.cardRead : cls.card}
      onClick={() => Open(DATA)}>
      <div className={cls.row}>
        <div className={cls.flex}>
          <div className={cls.row2}>
            <span className={cls.row2Span}>
              <Avatar
                className={cls.avatar}
                src={_get(DATA, 'data.user.profile', '')}
                alt="User"
              />
              <div className={cls.title}>
                <Tooltip
                  title={`Mark as ${DATA.seen ? 'unread' : 'read'}`}
                  tooltipId={`mark-as-${DATA.id}`}
                  iconId={`mark-as-${DATA.id}`}>
                  <span
                    onClick={(e) => handleSeen(e)}
                    className="cursor-pointer hover:bg-gray-hover-bg bg-transparent transition-all duration-300 w-6 h-6 border border-transparent hover:border-light-gray-border border-solid flex items-center justify-center rounded-full">
                    {DATA.seen ? (
                      <span className="w-2 h-2 border border-primary-blue border-solid rounded-full flex items-center justify-center" />
                    ) : (
                      <span className="w-2 h-2 bg-primary-blue rounded-full flex items-center justify-center" />
                    )}
                  </span>
                </Tooltip>
                {DATA.title}
              </div>
            </span>
            <div className={cls.date}>{getTimeDisplay(DATA.created_at)}</div>
          </div>
          <div className={cls.des}>
            {DATA.data?.type == 'chat' &&
              `${DATA?.data?.opponent?.name} (${DATA?.data?.opponent?.company}) : `}
            {DATA.body}
          </div>
          {/* <div className={cls.des}>{DATA.body.slice(0, 85) + ' ...'}</div> */}
          {/* {DATA.seen ? <CheckRounded className={cls.seen} /> : null} */}
          {DATA.type == 'chat' ? (
            <span className={cls.opponentName}>
              From : {DATA?.data?.opponent?.name}
            </span>
          ) : DATA.type == 'whatsapp-messages' ? (
            <span className={cls.opponentName}>
              From : {DATA.data?.message?.from_name} /{' '}
              {DATA?.data?.message?.from}
            </span>
          ) : null}
        </div>
      </div>
    </div>
  );
};
